import React, { useState, useEffect, useRef } from "react";
import { fade, makeStyles, withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import axios from "axios";
import { eventLabelGroupsConstants } from "../../constants/eventLabelGroups.contansts";
import { AgendaContainer } from "./components/AgendaContainer";
import { init } from "../../../components/EventLabel2/EventLabel2";

function AgendaModule(props) {
  const [agenda, setAgenda] = useState([]);
  const [speakers, setSpeakers] = useState([]);
  const [activeSpeaker, setActiveSpeaker] = useState(null);
  const [floorIsGive, setFloorIsGiven] = useState(false);
  const { eventId, clientKey, lang, connected, hubConnection, noneAllowedSpeakers, personTypes, template, clientName, preview, settings } = props;

  const { requestedEventId, getAgendaFromOtherEvent, allowRequestTheFloor, allowPointOfOrder, allowRequestLineOfSpeaker } = settings;
  
  const agendaListRef = useRef([]);
  const activeAgendaRef = useRef(null);
  const stateRef = useRef();

  /*   stateRef.current = state; */

  useEffect(() => {
    init(eventId, eventLabelGroupsConstants.AGENDA_LABEL_GROUP, lang);
    fetchAgenda();
    fetchSpeakers();
  }, []);
  useEffect( () => {
    if (hubConnection) {
      hubConnection.on("onSpeakersUpdate",onSpeakersUpdate);
      hubConnection.on("onActivateSpeaker", onActivateSpeaker);
      hubConnection.on("onDeactivateSpeaker", onDeactivateSpeaker );
      hubConnection.on("onAgendaUpdate", onAgendaUpdate);
      hubConnection.on("onAgendaClosed", onAgendaClosed);
    }
    return () => {
      if (hubConnection) {
        hubConnection.off("onSpeakersUpdate",onSpeakersUpdate);
        hubConnection.off("onActivateSpeaker", onActivateSpeaker);
        hubConnection.off("onDeactivateSpeaker", onDeactivateSpeaker );
        hubConnection.off("onAgendaUpdate", onAgendaUpdate);
        hubConnection.off("onAgendaClosed", onAgendaClosed);
      }
    }
  })
  const onSpeakersUpdate = (speakers) => {
    setSpeakers(speakers);
  }
  const onDeactivateSpeaker = () => {
    setActiveSpeaker(null)
  }
  const onActivateSpeaker = (activeSpeaker) => {
    setActiveSpeaker(activeSpeaker);
  }
  const onAgendaClosed = (speakers) => {
    setSpeakers(speakers);
    setActiveSpeaker(null);
  }
 
  const onAgendaUpdate = (agenda, agendaEventId) => {
    if((getAgendaFromOtherEvent && requestedEventId  === agendaEventId) || agendaEventId === eventId){
      setAgenda(agenda);
      handleScroll();
    }
  }
  const fetchAgenda = () => {
    axios
      .get(`./api/meeting/agenda/${getAgendaFromOtherEvent && requestedEventId ? requestedEventId : eventId}`)
      .then(({ data }) => {
        if (!data) return;
        const agendaItems = data.sort(function (a, b) {
          return a.sortOrder - b.sortOrder;
        });
        setAgenda(agendaItems);
        handleScroll();
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const fetchSpeakers = () => {
    axios
      .get(`./api/meeting/speakers/${eventId}`)
      .then(({ data }) => {
        if (data) setSpeakers(data);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleScroll = () => {
    const ref = activeAgendaRef.current;
    if (ref) ref.scrollIntoView({ block: "end", behavior: "smooth" });
  };

  const unassignRequest = (agendaItemId, parentId = null) => {
    if (!connected || !hubConnection || (hubConnection.connectionState != 1 && !preview)) return;
    hubConnection
      .invoke("removeSpeaker", {
        eventId,
        agendaItemId,
        clientKey,
        parentId,
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const requestTheFloor = (agendaItemId, speakerType, parentId = null) => {
    if (!connected || !hubConnection || (hubConnection.connectionState != 1 && !preview)) return;
    hubConnection
      .invoke("setSpeaker", {
        eventId,
        agendaItemId,
        clientKey,
        parentId,
        speakerType,
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const hasRequestedTheFloor = (agendaId, parentId = null) => {
    const hasRequested = speakers.find((s) => s.agendaItemId === agendaId && s.badgeNo === clientKey && s.parentInteractionSpeakerId === parentId && s.closedDateTime === null);
    return hasRequested;
  };
  const isSpeakerActive = (agendaId, parentId = null) => {
    const isActive = speakers.find((s) => s.agendaItemId === agendaId && s.badgeNo === clientKey && s.parentInteractionSpeakerId === parentId && s.closedDateTime === null && s.active === true);
    return isActive;
  };
  const getAgendaStyle = (group, status) => {
    switch (group) {
      case "Content":
        if (!template.interaction.agenda) {
          return {
            margin: 0,
            height: "100%",

            borderRadius: template ? template.content.borderRadius : undefined,
            backgroundColor: template ? template.content.backgroundColor : undefined,
          };
        } else {
          if (template.interaction.agenda && template.interaction.agenda.content) {
            return {
              ...template.interaction.agenda.content,
              margin: 0,
              borderStyle: "solid",
              height: "100%",
              boxShadow: "none !important",
            };
          }
        }
      case "Title":
        if (!template.interaction.agenda) {
          return {
            ...template.subtitle,
            margin: "10px 15px",
            marginBottom: 12,
            fontFamily: template.subtitle.fontFamily,
          };
        } else {
          if (template.interaction.agenda && template.interaction.agenda.title) {
            return { ...template.interaction.agenda.title };
          }
        }
      case "Subtitle":
        if (!template.interaction.agenda) {
          return {
            ...template.subtitle,
            margin: "10px 15px",
            marginBottom: 12,
            fontFamily: template.subtitle.fontFamily,
          };
        } else {
          if (template.interaction.agenda && template.interaction.agenda.subtitle) {
            return { ...template.interaction.agenda.subtitle };
          }
        }
      case "RowFrame":
        if (!template.interaction.agenda) {
          return {
            margin: "10px 5px",
            border: status == "ACTIVE" ? `3px solid ${template ? template.tcell.borderColor : "rgba(32, 168, 216, 1)"}` : "3px solid transparent",
            opacity: status == "PASSED" ? 0.6 : 1,
            boxShadow: "none",
            backgroundColor: status == "PASSED" ? template.tcell.borderColor : template.content.backgroundColor,
            padding: "5px",
          };
        } else {
          if (status == "DEFAULT")
            return {
              ...template.interaction.agenda.agendaItem,
              ...template.interaction.agenda.default.item,
              borderStyle: "solid",
              boxShadow: "none",
            };
          if (status == "ACTIVE")
            return {
              ...template.interaction.agenda.agendaItem,
              ...template.interaction.agenda.active.item,
              borderStyle: "solid",
              boxShadow: "none",
            };
          if (status == "PASSED")
            return {
              ...template.interaction.agenda.agendaItem,
              ...template.interaction.agenda.passed.item,
              borderStyle: "solid",
              boxShadow: "none",
            };
        }
      case "RowTitle":
        if (!template.interaction.agenda) {
          return template.text;
        } else {
          if (status == "DEFAULT") return template.interaction.agenda.default.title;
          if (status == "ACTIVE") return template.interaction.agenda.active.title;
          if (status == "PASSED") return template.interaction.agenda.passed.title;
        }
      case "RowText":
        if (!template.interaction.agenda) {
          return undefined;
        } else {
          if (status == "DEFAULT") return template.interaction.agenda.default.text;
          if (status == "ACTIVE") return template.interaction.agenda.active.text;
          if (status == "PASSED") return template.interaction.agenda.passed.text;
        }

      default:
        return undefined;
    }
  };

  const isAuthorizedSpeaker = () => {
    if (!clientName || clientName.includes("Guest_")) return false;
    return true;
  };
  const isAllowedSpeaker = () => {
    let allowed = true;
    if (noneAllowedSpeakers.length > 0 && personTypes) {
      noneAllowedSpeakers.map((n) => {
        if (personTypes.includes(n)) {
          allowed = false;
        }
      });
    }
    return allowed;
  };
  const api = {
    speakers,
    agenda,
    ...props,
    activeSpeaker,
    agendaListRef,
    isAllowedSpeaker,
    isAuthorizedSpeaker,
    isSpeakerActive,
    getAgendaStyle,
    hasRequestedTheFloor,
    activeAgendaRef,
    requestTheFloor,
    unassignRequest,
  };

  return <AgendaContainer {...api} />;
}

function mapStateToProps(state) {
  return {
    template: state.template.template ? state.template.template.content : null,
  };
}
export default connect(mapStateToProps)(AgendaModule);
